export default __webpack_public_path__ + "28ba3a3b687c36d388fae9ee372f38b7.png";